import { composeIO } from 'react-compose-io'
import { selecaoParceiroToDashboardIO } from './SelecaoParceiroToDashboard.IO'
import { SelecaoParceiroToDashboardView } from './SelecaoParceiroToDashboard.View'

export const SelecaoParceiroToDashboard = composeIO(SelecaoParceiroToDashboardView, selecaoParceiroToDashboardIO)
